import { FilterBuilderFilterType } from "@validereinc/common-components";
import { AssetTypeSchema } from "@validereinc/domain";
import { z } from "zod";

const COPFilterSchema = z.object({
  year_month: z.object({
    $gte: z.string().optional(),
    $lte: z.string().optional(),
  }),
  reporting_group_id: z.string().or(z.object({ $in: z.array(z.string()) })),
  "equipment.facility.name": z.string().optional(),
  "facility.name": z.string().optional(),
});

const CommonFilterSchema = z.object({
  asset_type: z.object({ $in: AssetTypeSchema }).or(AssetTypeSchema),
  year_month: z.string(),
  reporting_group_id: z.string().or(z.object({ $in: z.array(z.string()) })),
});

export const parseBackendFilterToFilterBuilderFormat = (
  backendFilterObject: Record<string, any>
) => {
  // "safe" filter has a compatible format with FilterBuilder component
  const safeFilter: FilterBuilderFilterType = {};

  if (COPFilterSchema.safeParse(backendFilterObject).success) {
    const yearMonthSafeRange = ["", ""];
    if (backendFilterObject.year_month.$gte) {
      yearMonthSafeRange[0] = backendFilterObject.year_month.$gte;
    }
    if (backendFilterObject.year_month.$lte) {
      yearMonthSafeRange[1] = backendFilterObject.year_month.$lte;
    }

    if (yearMonthSafeRange[0] && yearMonthSafeRange[1]) {
      safeFilter.$and = [
        { year_month: { $gte: yearMonthSafeRange[0] } },
        { year_month: { $lte: yearMonthSafeRange[1] } },
      ];
    } else if (yearMonthSafeRange[0]) {
      safeFilter.year_month = { $gte: yearMonthSafeRange[0] };
    } else if (yearMonthSafeRange[1]) {
      safeFilter.year_month = { $lte: yearMonthSafeRange[1] };
    }

    safeFilter.reporting_group_id = backendFilterObject.reporting_group_id;

    if (backendFilterObject?.["equipment.facility.name"]) {
      safeFilter["equipment.facility.name"] =
        backendFilterObject["equipment.facility.name"];
    }

    if (backendFilterObject?.["facility.name"]) {
      safeFilter["facility.name"] = backendFilterObject["facility.name"];
    }

    return safeFilter;
  }

  if (CommonFilterSchema.safeParse(backendFilterObject).success) {
    safeFilter.year_month = backendFilterObject.year_month;
    safeFilter.asset_type = backendFilterObject.asset_type;
    safeFilter.reporting_group_id = backendFilterObject.reporting_group_id;
    return safeFilter;
  }

  return backendFilterObject;
};
